import { Children, forwardRef } from 'react'
import { Stack, type StackProps } from '../../Stack'
import { listCss } from './List.css'

/** @deprecated */
export const List = forwardRef<HTMLElement, StackProps>(function List(
  { children, className, ...props },
  ref,
) {
  if (Children.count(children) === 0) {
    return null
  }

  return (
    <>
      <Stack
        as="ul"
        ref={ref}
        gap="1x"
        className={[listCss, className]}
        {...props}
        tabIndex={-1}
      >
        {children}
      </Stack>
    </>
  )
})
